import { useForm, bindField, zEmail } from "@npco/zeller-design-system/form";
import * as Input from "@npco/zeller-design-system/input";
import { ADT } from "pb.adt";
import { z } from "zod";

import { Layout as ModalLayout } from "../../../shared/layout";
import type { Page } from "../page";
import { PaymentMethodLinkForm } from "./payment-method-link-form";

const ValuesSchema = z.object({
	email: zEmail(),
});

export function PaymentMethodLinkEmail({
	page,
	defaultLayoutProps,
}: {
	page: Omit<ADT.Pick<Page, "PaymentMethodLinkEmail">, "$type">;
	defaultLayoutProps: ModalLayout.Defaults;
}) {
	const form = useForm(ValuesSchema, async ({ value }) => {
		await page.onSubmit(value.email);
	});

	return (
		<PaymentMethodLinkForm
			page={page}
			defaultLayoutProps={defaultLayoutProps}
			form={form}
		>
			{(isSubmitting) => (
				<form.Field
					name="email"
					children={(field) => (
						<Input.Text
							{...bindField(field)}
							label="Email"
							$input={{ required: true }}
							disabled={isSubmitting}
						/>
					)}
				/>
			)}
		</PaymentMethodLinkForm>
	);
}
